import React from 'react';
import ReactQuill from 'react-quill';

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['link', 'image'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ['clean']
];

const HTMLEditor = ({ data, onChange }) => (
  <ReactQuill
    value={data}
    onChange={onChange}
    modules={{ toolbar: toolbarOptions }}
    placeholder="Please enter text here..."
  />
);

export default HTMLEditor;
